import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { StyledBottomTagsContainer, StyledTag, StyledTagText } from '../styled';
import { AssetTagsProps } from '../types';
import { getPositionTagColor, getVolumeTagColor } from '../utils';

/**
 * Asset Tags Component
 * Displays volume and position indicator tags.
 * Tag values are i18n translation keys (communityStats namespace).
 */
export const AssetTags: FC<AssetTagsProps> = ({ tags }) => {
  const { t } = useTranslation('communityStats');
  const theme = useTheme();

  const volumeColors = getVolumeTagColor(tags.volumeTag);
  const positionColors = getPositionTagColor(tags.positionTag);

  return (
    <StyledBottomTagsContainer>
      <StyledTag
        borderColor={
          theme.palette[
            volumeColors.borderColor.split('.')[0] as 'warning' | 'info'
          ]?.main || volumeColors.borderColor
        }
        backgroundColor={volumeColors.backgroundColor}
      >
        <StyledTagText>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {t(tags.volumeTag as any)}
        </StyledTagText>
      </StyledTag>

      <StyledTag
        borderColor={(() => {
          const [group, key] = positionColors.borderColor.split('.');
          const paletteGroup = theme.palette[
            group as keyof typeof theme.palette
          ] as Record<string, string> | undefined;
          return (
            (key && paletteGroup?.[key]) ||
            (paletteGroup as unknown as string) ||
            positionColors.borderColor
          );
        })()}
        backgroundColor={(() => {
          const [group, key] = positionColors.backgroundColor.split('.');
          const paletteGroup = theme.palette[
            group as keyof typeof theme.palette
          ] as Record<string, string> | undefined;
          return (
            (key && paletteGroup?.[key]) ||
            (paletteGroup as unknown as string) ||
            positionColors.backgroundColor
          );
        })()}
      >
        <StyledTagText>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {t(tags.positionTag)}
        </StyledTagText>
      </StyledTag>
    </StyledBottomTagsContainer>
  );
};
